import type { ReactNode } from 'react'
import { Button, EmptyState, Skeleton } from '@amglobal/ui-shared'
import { useMeSessionQuery } from '@/features/auth/hooks/use-me-session-query'
import { proExitWorkspaceAllowed } from '@/shared/lib/staff-capabilities'

type Props = {
  children: ReactNode
}

export function RequireProExitWorkspace({ children }: Props) {
  const session = useMeSessionQuery()

  if (session.isLoading) {
    return <Skeleton className="mx-auto mt-8 h-48 max-w-3xl rounded-xl" />
  }

  const roles = session.data?.roles ?? []
  const capabilities = session.data?.capabilities ?? []
  const allowed = proExitWorkspaceAllowed(capabilities, roles)

  if (allowed) return children

  return (
    <EmptyState
      title="PRO exit access only"
      description="This area is for PRO desk accounts with employee exit permissions."
      action={
        <Button type="button" variant="secondary" onClick={() => window.location.assign('/account/access')}>
          View my access
        </Button>
      }
    />
  )
}
